import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Select from 'react-select';

import { formatEnumsForDropDown } from "../../utils/helperFunction";
import { Enumeration, PropertyInfo, PropertyLocation } from "../../utils/interface";
import StateDropDown from "../StateDropdown";
import CityDropdown from "../CityDropdown";

interface EditPropertyFormProps {
  propertyTypes: Enumeration[];
  propertyInfo: PropertyInfo;
  onUpdatePropertyInfo: (propertyInfo: PropertyInfo) => void;
}

const EditPropertyForm: React.FC<EditPropertyFormProps> = ({
  propertyTypes,
  propertyInfo,
  onUpdatePropertyInfo,
}) => {
  const [propertyDetails, setPropertyDetails] = useState<PropertyInfo>(propertyInfo);
  const [propertyLocation, setPropertyLocation] = useState<PropertyLocation>(propertyInfo.propertyLocation);

  const onChangeFieldValue = (value: object) => {
    setPropertyDetails({ ...propertyDetails, ...value });
  }
  const onChangeLocationFieldValue = (value: object) => {
    setPropertyLocation({ ...propertyLocation, ...value });
  }
  const handleSubmit = (
    event: React.FormEvent<HTMLFormElement>,
    onClickUpdate: (propertyInfo: PropertyInfo
    ) => void, propertyInfo: PropertyInfo) => {
    event.preventDefault();
    onClickUpdate(propertyInfo);
  };

  useEffect(() => {
    setPropertyDetails(propertyInfo)
    if (propertyInfo.propertyLocation) {
      setPropertyLocation(propertyInfo.propertyLocation);
    }
  }, [propertyInfo])

  return (<>
    <Container>
      <Form onSubmit={(event) => handleSubmit(event, onUpdatePropertyInfo, {...propertyDetails, propertyLocation})}>
        <Form.Group className="mb-3 mt-4" controlId="verified-property">
          <Form.Check
            type="checkbox"
            label={<span style={{ color: 'blue', fontSize: '18px', fontWeight: 'bold' }}>Verified Property</span>}
            checked={propertyDetails.isVerified}
            onChange={(e) => onChangeFieldValue({ isVerified: e.target.checked })}
          />
        </Form.Group>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="property-id">
              <Form.Label><strong>Property Id</strong></Form.Label>
              <Form.Control
                type="text"
                value={propertyDetails.propertyId}
                disabled
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="created-at">
              <Form.Label><strong>Posted On</strong></Form.Label>
              <Form.Control
                type="date"
                name="createdAt"
                value={propertyDetails.createdAt}
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="property-type">
              <Form.Label><strong>Property Type</strong></Form.Label>
              <Select
                options={formatEnumsForDropDown(propertyTypes)}
                isSearchable
                placeholder=""
                value={
                  formatEnumsForDropDown(propertyTypes)
                    .find(type => type.value === propertyDetails.propertyTypeEnumId)
                }
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    onChangeFieldValue({ propertyTypeEnumId: selectedOption.value })
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="owner">
              <Form.Label><strong>Owner</strong></Form.Label>
              <Form.Control
                type="text"
                name="mobile"
                value={propertyDetails.ownerFullName}
                disabled
              />
            </Form.Group>
          </Col>
          <Col><Form.Group className="mb-3" controlId="owner-mobile">
            <Form.Label><strong>Mobile</strong></Form.Label>
            <Form.Control
              type="text"
              name="mobile"
              value={propertyLocation.mobile}
              onChange={(e) => onChangeLocationFieldValue({ mobile: e.target.value })}
              required
            />
          </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3" controlId="property-title">
          <Form.Label><strong>Property Title</strong></Form.Label>
          <Form.Control
            type="text"
            value={propertyDetails.propertyTitle}
            onChange={(e) => onChangeFieldValue({ propertyTile: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="description">
          <Form.Label><strong>Description</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={propertyDetails.description}
            onChange={(e) => onChangeFieldValue({ description: e.target.value })}
          />
        </Form.Group>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="addressLine1">
              <Form.Label><strong>Address 01</strong></Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={propertyLocation.addressLine1}
                onChange={(e) => onChangeLocationFieldValue({ addressLine1: e.target.value })}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="addressLine2">
              <Form.Label><strong>Address 02</strong></Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={propertyLocation.addressLine2}
                onChange={(e) => onChangeLocationFieldValue({ addressLine2: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="landmark">
              <Form.Label><strong>Landmark</strong></Form.Label>
              <Form.Control
                type="text"
                value={propertyLocation.landmark}
                onChange={(e) => onChangeLocationFieldValue({ landmark: e.target.value })}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="locality">
              <Form.Label><strong>Locality</strong></Form.Label>
              <Form.Control
                type="text"
                value={propertyLocation.locality}
                onChange={(e) => onChangeLocationFieldValue({ locality: e.target.value })}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="edit-state">
              <StateDropDown
                onStateChange={() => { }}
                selectedStateISOCode={propertyLocation.stateISOCode}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="edit-city">
              <CityDropdown
                stateCode={propertyLocation.stateISOCode}
                onCityChange={() => { }}
                selectedCity={propertyLocation.city}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="pincode">
              <Form.Label><strong>Pincode</strong></Form.Label>
              <Form.Control
                type="text"
                value={propertyLocation.pincode}
                onChange={(e) => onChangeLocationFieldValue({ pincode: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>
        <Button variant="primary" type="submit">
          Update
        </Button>
      </Form>
    </Container>
  </>)
};

export default EditPropertyForm;
